import React from 'react';
import cn from 'classnames';
import i18n from '../../../i18n';
import {Status, Statuses} from '../../../utils/hooks';
import scanningIcon from '../../../assets/img/loading-spinner.gif';
import successIcon from '../../../assets/success-small-icon.svg';
import errorIcon from '../../../assets/error-icon.svg';
import uploadStyles from '../../acommon/FieldUploadFile/UploadFile.module.sass';
import {ActivityImage, ActivityIndicatorWrapper, Title} from '../styled';

type ActivityIndicatorStatus = Statuses.loading | Statuses.success;

type ActivityDescriptorType = {icon?: string; text: string};
const activityDescriptors = {
  [Statuses.loading]: {icon: scanningIcon, text: i18n.t('scanning')},
  [Statuses.success]: {icon: successIcon, text: i18n.t('success_exclamation')},
  [Statuses.error]: {icon: errorIcon, text: i18n.t('error')},
};

const getActivityIndicator = (status?: Status): ActivityDescriptorType | null => {
  if (!status || !(status in activityDescriptors)) return null;
  return activityDescriptors[status as ActivityIndicatorStatus];
};

const ActivityIndicator = React.memo(
  ({
    activityIndicator,
    className,
  }: {
    activityIndicator: ActivityDescriptorType | null;
    className?: string;
  }) => {
    return (
      <ActivityIndicatorWrapper className={className}>
        <div className={cn(uploadStyles.wrapper)}>
          <ActivityImage src={activityIndicator?.icon} alt={'activityIndicator'} />
          {activityIndicator?.text && <Title>{activityIndicator?.text}</Title>}
        </div>
      </ActivityIndicatorWrapper>
    );
  },
);

export {ActivityIndicator, getActivityIndicator};
